<template>
<div class="chapter">
<div class="inner_page">
<p class="int-head"><a id="page_6"></a>Introduction</p>
<p class="noindent-c"><i>“Have nothing in your house that you do not find useful or believe to be beautiful.” —William Morris</i></p>
<p class="noindent">Taking the advice from Mr. Morris, we can transform our useful into beautiful and thereby have the best of both worlds: a tablet purse becomes an embroidered masterpiece and a functional tea cozy can double as an eye-catching centerpiece on our table.</p>
<p class="noindent">Welcome to a world of crazy quilting, where any type of fabric goes: bright and bold, subdued Japanese cottons, “upcycled” wool, pretty ginghams, and vintage doilies.</p>
<p class="noindent">Each project comes with detailed assembly instructions and easy-to-follow stitch maps. The pullout pattern sheets include full-size patterns for each project.</p>
<p class="noindent">The comprehensive stitch dictionary includes silk ribbon and basic embroidery, beading, and embellishing stitches.</p>
<p class="noindent">Whether you are a new crazy quilter or an experienced crazy quilter looking for smaller projects to go “crazy” on, I am sure you will find something to inspire you.</p>
<p class="image1"><img alt="" src="images/pg6_1.jpg"/></p>
<p class="cap">China flower pincushion</p>
<p class="image1"><img alt="" src="images/pg6_2.jpg"/></p>
<p class="cap">Tea Cozy and Tablet Purse</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_intro.vue?cfc94a2e